import React, { useRef, useState } from 'react'

import { Box, Chip, Popover, Typography } from '@material-ui/core'
import { Info as InfoIcon } from 'react-feather'

import { Dai } from 'components'

import useStyles from './styles'
import constants from 'constants/index'

const ActivityAnalysisDaiButton = ({ onClick, disabled }) => {
  const [open, setOpen] = useState(false)

  const anchorRef = useRef(null)
  const classes = useStyles()

  const { TAGS, GROUP_TAGS } = constants.dai.solutions

  const handleMouseEnter = () => {
    if (!disabled) setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  const handleClick = () => {
    handleMouseLeave()
    onClick()
  }

  return (
    <Box ref={anchorRef}>
      <Dai.Permitted
        tag={[
          GROUP_TAGS.GOVERNANCE_PROJECTS,
          TAGS.GOVERNANCE_PROJECT_ACTIVITY_ANALYSIS,
          TAGS.GOVERNANCE_PROJECT_EVIDENCE_ANALYSIS,
        ]}
      >
        <Dai.StarButton
          size="small"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
          disabled={disabled}
        >
          Fazer análise com a DAI
        </Dai.StarButton>
      </Dai.Permitted>

      <Popover
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        className={classes.popover}
        classes={{ paper: classes.paper }}
        disableRestoreFocus
        onClose={handleMouseLeave}
        PaperProps={{
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
        }}
      >
        <Box className={classes.header}>
          <InfoIcon size={16} className={classes.infoIcon} />
          <Typography variant="subtitle2" className={classes.title}>
            Funcionalidade em Beta
          </Typography>
          <Chip label="Beta" size="small" className={classes.betaChip} />
        </Box>
        <Typography variant="body2" className={classes.description}>
          Os conteúdos, análises e recomendações gerados por esta Inteligência
          Artificial encontram-se em versão beta e são produzidos de forma
          automatizada. Embora a tecnologia empregada busque precisão e
          qualidade, podem ocorrer erros, imprecisões ou interpretações
          incorretas. A pré-análise fornecida pela IA possui caráter&nbsp;
          <b>apenas indicativo</b> e <b>não garante</b> que os resultados finais
          da avaliação sejam alcançados. Todos os resultados&nbsp;
          <b>devem ser revisados e validados por um profissional</b>, não
          devendo ser utilizados sem supervisão humana. Para mais informações,
          consulte nossas políticas.
        </Typography>
        <Typography variant="caption" display="block" className={classes.note}>
          <b>Nota:</b> A DAI suporta apenas a análise de documentos em
          formato&nbsp;
          <b>PDF</b>.
        </Typography>
      </Popover>
    </Box>
  )
}

export default ActivityAnalysisDaiButton
